import styled from "styled-components"
import { compose, typography, color } from "styled-system"

const Span = styled.span`
  display: block;
  ${compose(typography, color)}
`

export default Span
